import { AxiosPromise } from 'axios';
import axios from 'axios';
import { IEducationArticleParams, IGetEducationArticle, IGetEducationArticles } from '../models/homepageManagementEducationInfo.model';
import QueryString from 'qs';

const uri = '/mgmt/homepage-management/education-info';

export const getEducationArticles = (params: IEducationArticleParams): AxiosPromise<IGetEducationArticles> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}?${qsParams}`);
};

export const getEducationArticle = (bulletinCode: number): AxiosPromise<IGetEducationArticle> => {
  return axios.get(`${uri}/${bulletinCode}`);
};

export const createEducationArticle = (data: FormData): AxiosPromise => {
  return axios.post(uri, data);
};

export const updateEducationArticle = (bulletinCode: number, data: FormData): AxiosPromise => {
  return axios.put(`${uri}/${bulletinCode}`, data);
};

export const deleteEducationArticle = (bulletinCode: number): AxiosPromise => {
  return axios.delete(`${uri}/${bulletinCode}`);
};
